package one.healthium.today.ui.models

import one.healthium.base.utils.Formatters.formatWeight
import kotlin.time.Instant
import androidx.compose.runtime.Immutable

@Immutable
data class UpdateWeightUiModel(
    val currentWeight: Float,
    val date: Instant?,
    val isMetric: Boolean,
) {
    val displayValue = currentWeight.formatWeight(isMetric)
}
